<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/fee-master" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.EditFeeMaster") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.FeeMasterCode')"
              >
                <vs-input
                  :label="$t('setup.label.FeeMasterCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.feeMasterData.feeCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.FeeMasterDescription')"
              >
                <vs-input
                  :label="$t('setup.label.FeeMasterDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.feeMasterData.feeDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-6 font-semibold"
                  >{{ $t("setup.label.FeeMasterTransactionType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.FeeMasterTransactionType')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ReportsData.transactionTypeDatas"
                    v-model="Reports.feeMasterData.transactionType"
                    :reduce="(name) => name.mCodeValue"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-6 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-6 font-semibold"
                  >{{ $t("setup.label.ChargeCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="chargeCode"
                    :options="ReportsData.chargeDatas"
                    v-model="Reports.feeMasterData.chargeCode"
                    :reduce="(name) => name.chargeCode"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-6 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>
                {{ $t("setup.label.VariablePricing") }}
              </h4>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-1/4">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Regions")
                }}</small>
                <v-select
                  label="regionName"
                  :options="ReportsData.regionDatas"
                  v-model="Reports.regionName"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <!-- <template v-slot:option="option">{{ option.item }}</template> -->
                </v-select>
              </div>
            </div>
            <div class="vx-col w-1/4">
              <vs-input
                :label="$t('setup.label.Amount')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="Reports.amount"
              />
            </div>
            <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                icon-pack="feather"
                icon="icon-plus"
                :disabled="!Reports.regionName || !Reports.amount"
                :title="$t('setup.lable.Add')"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="block overflow-x-auto">
                <table class="w-full">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Regions") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Price") }}</b>
                    </td>
                    <td class="tHeadCenter">
                      <b>{{ $t("setup.label.Action") }}</b>
                    </td>
                  </tr>
                  <tr
                    v-for="(
                      Reports, index
                    ) in Reports.feeMasterRegionPricesDatas"
                    :key="index"
                  >
                    <td>{{ getRegionName(Reports.regionId) }}</td>
                    <td>{{ Reports.amount }}</td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <button
                          @click="removeItem(index)"
                          class="bGNone border-none view_editTable_btn"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('setup.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="editfeemaster"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  chargeCode: "",
  defaultFeeAmount: 0,
  feeCode: "",
  feeDescription: "",
  isRefundable: "N",
  locale: "en",
  regionPrices: [],
  removeRegionPrices: [],
  transactionType: "",
};

export default {
  data() {
    return {
      Reports: { feeMasterData: ReportsEmptyObj },
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.feeMaster.FeeMaster,
    }),
  },
  methods: {
    removeItem(i) {
      this.Reports.feeMasterRegionPricesDatas.splice(i, 1);
    },
    getRegionName(regionId) {
      const region = this.Reports.regionDatas.find((r) => r.id === regionId);
      return region ? region.regionName : "Unknown Region";
    },
    addParameter() {
      try {
        let crateParameter = {
          regionName: this.Reports.regionName.regionName,
          regionId: this.Reports.regionName.id,
          amount: this.Reports.amount,
        };
        if (this.Reports.regionName !== "") {
          this.Reports.feeMasterRegionPricesDatas = [
            ...this.Reports.feeMasterRegionPricesDatas,
            crateParameter,
          ];
          this.Reports.regionName = "";
          this.Reports.amount = "";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editfeemaster() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        this.Reports.chargeCode = this.Reports.feeMasterData.chargeCode;
        this.Reports.defaultFeeAmount =
          this.Reports.feeMasterData.defaultFeeAmount;
        this.Reports.feeCode = this.Reports.feeMasterData.feeCode;
        this.Reports.feeDescription = this.Reports.feeMasterData.feeDescription;
        this.Reports.transactionType =
          this.Reports.feeMasterData.transactionType;
        this.Reports.locale = "en";
        this.Reports.isRefundable = "N";
        this.Reports.removeRegionPrices = [];

        this.Reports.regionPrices = [];
        let i = 0;
        for (let temp of this.Reports.feeMasterRegionPricesDatas) {
          temp.locale = "en";

          delete this.Reports.feeMasterRegionPricesDatas[i].regionName;
          this.Reports.feeMasterRegionPricesDatas[i].id = temp.regionId;
          this.Reports.regionPrices.push(temp);
        }
        delete this.Reports.chargeDatas;
        delete this.Reports.transactionTypeDatas;
        delete this.Reports.regionDatas;
        delete this.Reports.chargeDatas;
        delete this.Reports.feeMasterData;
        delete this.Reports.feeMasterRegionPricesDatas;
        delete this.Reports.amount;
        delete this.Reports.regionName;

        await this.$store.dispatch("feeMaster/editfeemasterAction", {
          id: this.id,
          data: this.Reports,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Fee Master Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/fee-master`);
        this.resetForm();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getfeemaster() {
      try {
        await this.$store.dispatch("feeMaster/setfeemaster", this.id);
        this.Reports = this.ReportsData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push(`/setup/fee-master`);
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.id = this.$route.params.id;
    this.getfeemaster();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
